export default (num, places = 2) => {
  if (num || typeof num === 'number') {
    let pair = (`${num}e`).split('e')
    const value = Math.round(`${pair[0]}e${+pair[1] + places}`)
    pair = (`${value}e`).split('e')
    return +(`${pair[0]}e${+pair[1] - places}`)
  }
  return num
}
